module.exports = __webpack_public_path__ + "static/img/trazdia.e3abe05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/thumbnails/projects/trazdia.png
// module id = G6aX
// module chunks = 0